/**
 * Multi-variant selection for Shopify Impulse theme
 * 
 * This script adds functionality to select multiple variants with different quantities
 * and add them to cart simultaneously, and properly updates inventory status.
 * Updated to include app data properties from hidden inputs.
 */

document.addEventListener('DOMContentLoaded', function() {

  const productSectionFind = document.querySelector('.product-sec-gg');
  
  if(productSectionFind){
    const productForms = document.querySelectorAll('.product-single__form');  
    if (!productForms.length) return;

    productForms.forEach(form => {
      setupMultiVariantForm(form);
    });
  }
});

function setupMultiVariantForm(form) {
  const originalVariantSelector = form.querySelector('[data-product-select]');
  const originalQuantityInput = form.querySelector('input[name="quantity"]');
  const originalAddToCartBtn = form.querySelector('[data-add-to-cart]');
  const originalAddToCartText = form.querySelector('[data-add-to-cart-text]');
  const productSection = form.closest('[data-section-type="product"]');
  const colorSelector = form.querySelector('.variant-input-wrap[data-index="option1"]');
  const sizeSelector = form.querySelector('.variant-input-wrap[data-index="option2"]');
  if (!originalVariantSelector || !productSection) return;

  // Get the inventory status block
  const inventoryStatusBlock = document.querySelector('.product-block--sales-point');
  console.log('Inventory status block---->:', inventoryStatusBlock);
  
  if (colorSelector) colorSelector.style.display = 'block';
  if (sizeSelector) sizeSelector.style.display = 'none';
  if (originalQuantityInput?.closest('.js-qty__wrapper')) originalQuantityInput.closest('.js-qty__wrapper').style.display = 'none';

  const variantContainer = document.createElement('div');
  variantContainer.className = 'multi-variant-container';
  variantContainer.innerHTML = `
    <style>
      .multi-variant-container { margin: 25px 0; }
      .variant-size-table-header, .variant-size-row { display: flex; align-items: center; padding: 10px 0; border-bottom: 1px solid #e8e8e1; }
      .variant-size-table-header { font-weight: bold; }
      .col-size { width: 100px; text-align: left; }
      .col-price { flex-grow: 1; text-align: left; }
      .col-quantity { width: 120px; text-align: center; }
      .variant-size-row.out-of-stock { opacity: 0.6; }
      .variant-size { width: 100px; font-weight: 500; }
      .variant-price { flex-grow: 1; }
      .variant-quantity-wrapper { width: 120px; display: flex; justify-content: center; align-items: center; }
      .variant-quantity { width: 40px; text-align: center; border: 1px solid #e8e8e1; padding: 5px 0; font-size: 14px; margin: 0 5px; }
      .quantity-btn { width: 25px; height: 25px; background: #fff; border: 1px solid #e8e8e1; cursor: pointer; font-size: 16px; line-height: 1; display: flex; align-items: center; justify-content: center; }
      .quantity-btn:hover { background: #f6f6f6; }
      .quantity-btn:disabled { opacity: 0.5; cursor: not-allowed; }
      .variant-checkbox { margin-right: 10px; }
      .total-container { display: flex; justify-content: space-between; margin-top: 15px; }
      .total-quantity-display { font-weight: bold; font-size: 1.1em; }
      .total-price-display { font-weight: bold; font-size: 1.1em; text-align: right; }
      .select-variants-header { font-size: 1.2em; margin-bottom: 15px; font-weight: 500; }
      .inventory-status { font-size: 0.9em; color: #d82c0d; margin-left: 10px; }
      .inventory-status.in-stock { color: #056e38; }
    </style>
    <div class="select-variants-header">Select Variants and Quantities</div>
    <div class="variant-size-table-header">
      <div class="col-size">Size</div>
      <div class="col-price">Price</div>
      <div class="col-quantity">Quantity</div>
    </div>
    <div class="variants-list"></div>
    <div class="total-container">
      <div class="total-quantity-display">Total Quantity: 0</div>
      <div class="total-price-display">Total: $0.00</div>
    </div>
  `;

  const hideNew = document.querySelectorAll('.variant-label-to-hideg');
  
  if (hideNew.length > 0) {
    const parentNode = hideNew[0].parentNode;
    parentNode.insertBefore(variantContainer, hideNew[0]);
    
    hideNew.forEach((item) => {
      item.remove(); 
    });
  } else {
    originalAddToCartBtn.parentNode.insertBefore(variantContainer, originalAddToCartBtn);
  }

  const variantJSON = productSection.querySelector('[data-variant-json]');
  if (!variantJSON) return;
  const variants = JSON.parse(variantJSON.innerHTML);
  const variantsList = variantContainer.querySelector('.variants-list');
  const totalPriceDisplay = variantContainer.querySelector('.total-price-display');
  const totalQuantityDisplay = variantContainer.querySelector('.total-quantity-display');

  // Store the current selected color to detect changes
  let currentSelectedColor = null;
  // Store the currently focused variant (for inventory display)
  let currentFocusedVariantId = null;

  function getSelectedColorOption() {
    const selected = form.querySelector('.variant-input-wrap[data-index="option1"] input:checked');
    if (selected) return selected.value;
    
    const colorStamp = document.querySelector('.color-swatch--active');

    if (colorStamp) {
      const colorValue = colorStamp.getAttribute('data-value') || 
                          colorStamp.getAttribute('data-color-name') ||
                          colorStamp.getAttribute('title');
      if (colorValue) return colorValue;
    }
    
    const url = new URL(window.location.href);
    const variantId = url.searchParams.get('variant');
    if (variantId) {
      const variant = variants.find(v => v.id.toString() === variantId);
      if (variant) return variant.option1;
    }
    
    if (variants.length > 0) {
      return variants[0].option1;
    }
    
    return null;
  }

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const value = parseInt(cents, 10) || 0;
    const dollars = (value / 100).toFixed(2);
    return `$${dollars}`;
  }

  function updateTotalPrice() {
    let total = 0;
    let totalQuantity = 0;
    let selected = false;
    
    variantsList.querySelectorAll('.variant-size-row').forEach(row => {
      const qty = parseInt(row.querySelector('.variant-quantity').value) || 0;
      if (qty > 0) {
        selected = true;
        total += parseFloat(row.dataset.price) * qty;
        totalQuantity += qty;
      }
    });
    
    totalPriceDisplay.textContent = `Total: ${formatMoney(total * 100)}`;
    totalQuantityDisplay.textContent = `Total Quantity: ${totalQuantity}`;
    
    if (originalQuantityInput) originalQuantityInput.value = selected ? 1 : 0;
  }

  // Function to update inventory status display based on variant
  function updateInventoryStatus(variantId, size) {
    console.log('Updating inventory status for variant:', variantId, 'size:', size);
    // Skip if no inventory feature is present
    if (!window.inventories || !inventoryStatusBlock) return;
    
    const productId = Object.keys(window.inventories)[0];
    if (!productId || !window.inventories[productId]) return;
    
    const variantInventory = window.inventories[productId][variantId];
    console.log('Variant inventory:----->', variantInventory);
    if (!variantInventory) return;
    
    // Update the inventory display elements
    const inStockElement = inventoryStatusBlock.querySelector('.sales-point:first-child');
    const incomingElement = inventoryStatusBlock.querySelector('[data-incoming-inventory]');
    const inventoryTextElement = inventoryStatusBlock.querySelector('[data-product-inventory]');
    
    if (!inStockElement || !inventoryTextElement) return;
    
    const threshold = inventoryTextElement.dataset.threshold || 10;
    const isLowInventory = variantInventory.quantity <= threshold && variantInventory.quantity > 0;
    
    // Update in-stock message with size
    if (variantInventory.quantity > 0) {
      inStockElement.classList.remove('hide');
      
      // Update low inventory message
      if (isLowInventory) {
        inventoryTextElement.closest('.icon-and-text').classList.add('inventory--low');
        inventoryTextElement.textContent = `Size: ${size} - Only ${variantInventory.quantity} Left`;
      } else {
        inventoryTextElement.closest('.icon-and-text').classList.remove('inventory--low');
        inventoryTextElement.textContent = `Size: ${size} - In Stock`;
      }
    } else {
      inStockElement.classList.add('hide');
    }
    
    // Update incoming inventory message
    if (incomingElement) {
      const showIncoming = variantInventory.quantity <= 0 && 
                           variantInventory.policy === 'continue' && 
                           variantInventory.incoming;
                           
      if (showIncoming) {
        incomingElement.classList.remove('hide');
        const incomingTextElement = incomingElement.querySelector('.js-incoming-text');
        
        if (incomingTextElement) {
          if (variantInventory.next_incoming_date) {
            incomingTextElement.textContent = `Size: ${size} - Will Be In Stock After ${variantInventory.next_incoming_date}`;
          } else {
            incomingTextElement.textContent = `Size: ${size} - Waiting For Stock`;
          }
        }
      } else {
        incomingElement.classList.add('hide');
      }
    }
    
    // Save current focused variant
    currentFocusedVariantId = variantId;
  }

  function renderVariantRows() {
    const selectedColor = getSelectedColorOption();
    
    // Update the currentSelectedColor
    currentSelectedColor = selectedColor;
    
    variantsList.innerHTML = '';
    
    if (!selectedColor) {
      console.error('No selected color found, using first available variant');
      if (variants.length > 0) {
        const firstVariant = variants[0];
        const firstColor = firstVariant.option1;
        
        if (colorSelector) {
          const colorInput = colorSelector.querySelector(`input[value="${firstColor}"]`);
          if (colorInput) colorInput.checked = true;
        }
        
        setTimeout(renderVariantRows, 10);
        return;
      }
    }
    
    let filteredVariants = variants.filter(variant => 
      !selectedColor || variant.option1 === selectedColor
    );
    
    if (filteredVariants.length === 0) {
      console.warn('No variants found for color:', selectedColor);
      filteredVariants = [...variants];
    }
    
    const sizeMap = {};
    filteredVariants.forEach(variant => {
      const size = variant.option2 || variant.title;
      if (!sizeMap[size]) sizeMap[size] = variant;
    });

    Object.entries(sizeMap).forEach(([size, variant]) => {
      const available = variant.available;
      const variantId = variant.id;
      
      // Check inventory status if available
      let inventoryStatus = '';
      let inventoryClass = '';
      
      if (window.inventories && window.inventories[productSection.dataset.sectionId]) {
        const variantInventory = window.inventories[productSection.dataset.sectionId][variantId];
        if (variantInventory) {
           const threshold = 10; // Default threshold or get from settings
           console.log('Threshold:----->', threshold);
          if (variantInventory.quantity <= threshold && variantInventory.quantity > 0) {
            inventoryStatus = `Only ${variantInventory.quantity} left!`;
            inventoryClass = 'inventory--low';
          } else if (variantInventory.quantity > 0) {
            inventoryStatus = 'In stock';
            inventoryClass = 'in-stock';
          } else {
            inventoryStatus = variantInventory.policy === 'continue' ? 'Out of stock' : 'Sold out';
            inventoryClass = '';
          }
        }
      }

      const row = document.createElement('div');
      row.className = `variant-size-row ${available ? '' : 'out-of-stock'}`;
      row.dataset.variantId = variant.id;
      row.dataset.price = (variant.price / 100).toFixed(2);
      row.dataset.color = variant.option1;
      row.dataset.size = size;

      row.innerHTML = `
        <div class="variant-size">
          <input type="checkbox" class="variant-checkbox" ${available ? '' : 'disabled'}>
          ${size}
          ${inventoryStatus ? `<span class="inventory-status ${inventoryClass}">${inventoryStatus}</span>` : ''}
        </div>
        <div class="variant-price">${formatMoney(variant.price)}</div>
        <div class="variant-quantity-wrapper">
          <button type="button" class="quantity-btn quantity-minus" ${available ? '' : 'disabled'}>−</button>
          <input type="number" class="variant-quantity" value="0" min="0" ${available ? '' : 'disabled'}>
          <button type="button" class="quantity-btn quantity-plus" ${available ? '' : 'disabled'}>+</button>
        </div>
      `;

      variantsList.appendChild(row);

      const checkbox = row.querySelector('.variant-checkbox');
      const qtyInput = row.querySelector('.variant-quantity');
      const minusBtn = row.querySelector('.quantity-minus');
      const plusBtn = row.querySelector('.quantity-plus');

      // Add event to update inventory display when focusing on this variant
      row.addEventListener('mouseenter', function() {
        updateInventoryStatus(variant.id, size);
      });

      checkbox.addEventListener('change', () => {
        qtyInput.value = checkbox.checked ? (qtyInput.value === '0' ? '1' : qtyInput.value) : '0';
        updateTotalPrice();
        
        // Update inventory display for this variant
        updateInventoryStatus(variant.id, size);
      });

      qtyInput.addEventListener('change', () => {
        checkbox.checked = parseInt(qtyInput.value) > 0;
        updateTotalPrice();
      });

      qtyInput.addEventListener('focus', () => {
        // Update inventory display for this variant
        updateInventoryStatus(variant.id, size);
      });

      minusBtn.addEventListener('click', () => {
        const val = Math.max(0, parseInt(qtyInput.value) - 1);
        qtyInput.value = val;
        checkbox.checked = val > 0;
        updateTotalPrice();
      });

      plusBtn.addEventListener('click', () => {
        const val = parseInt(qtyInput.value) + 1;
        qtyInput.value = val;
        checkbox.checked = true;
        updateTotalPrice();
        
        // Update inventory display for this variant
        updateInventoryStatus(variant.id, size);
      });
    });
    
    updateTotalPrice();
    
    // Update inventory status for the first variant by default
    if (filteredVariants.length > 0) {
      const firstVariant = filteredVariants[0];
      const firstSize = firstVariant.option2 || firstVariant.title;
      updateInventoryStatus(firstVariant.id, firstSize);
    }
  }

  // Listen for color selector changes
  if (colorSelector) {
    colorSelector.querySelectorAll('input').forEach(input => {
      input.addEventListener('change', () => {
        console.log('Color selector changed to:', input.value);
        setTimeout(renderVariantRows, 100);
      });
    });

    document.querySelectorAll('.color-swatch').forEach(swatch => {
      swatch.addEventListener('click', () => {
        console.log('Color swatch clicked');
        setTimeout(renderVariantRows, 200);
      });
    });
  }
  
  // Add event listener for variant change events from theme.js
  productSection.addEventListener('variantChange', function(event) {
    console.log('Variant change event detected:', event.detail);
    
    if (event.detail && event.detail.variant) {
      const newColor = event.detail.variant.option1;
      const newSize = event.detail.variant.option2 || event.detail.variant.title;
      
      // Check if the color has changed
      if (newColor !== currentSelectedColor) {
        console.log(`Color changed from ${currentSelectedColor} to ${newColor}`);
        setTimeout(renderVariantRows, 100);
      }
      
      // Update inventory for new variant with size
      updateInventoryStatus(event.detail.variant.id, newSize);
    }
  });
  
  // Also listen for the document-level event
  document.addEventListener('variant:change', function(event) {
    console.log('Document-level variant change event detected:', event.detail);
    
    if (event.detail && event.detail.variant) {
      const newColor = event.detail.variant.option1;
      const newSize = event.detail.variant.option2 || event.detail.variant.title;
      
      // Check if the color has changed
      if (newColor !== currentSelectedColor) {
        console.log(`Color changed from ${currentSelectedColor} to ${newColor}`);
        setTimeout(renderVariantRows, 100);
      }
      
      // Update inventory for new variant with size
      updateInventoryStatus(event.detail.variant.id, newSize);
    }
  });

  if (originalAddToCartBtn) {
    originalAddToCartBtn.addEventListener('click', function(e) {
      e.preventDefault();
      const selections = [];
      const selectedColor = getSelectedColorOption();
      
      console.log('Selected color for adding to cart:', selectedColor);
      
      // Get app data from hidden inputs
      const appData = {};
      const hiddenInputs = document.querySelectorAll('.gpo-hidden-inputs input[type="hidden"]');
      console.log('Hidden inputs:---->', hiddenInputs);

      hiddenInputs.forEach(input => {
        if (input.name && input.name.includes('properties[')) {
          const propertyName = input.name.replace('properties[', '').replace(']', '');
          console.log('Property name--->:', propertyName);
          appData[propertyName] = input.value;
        }
      });
      
      console.log('App data from hidden inputs:', appData);
      
      variantsList.querySelectorAll('.variant-size-row').forEach(row => {
        const qty = parseInt(row.querySelector('.variant-quantity').value);
        if (qty > 0) {
          
          const rowSize = row.dataset.size;
          const rowColor = row.dataset.color;
          
          let variantId = row.dataset.variantId;
          
          if (selectedColor && rowColor !== selectedColor) {
            const matchingVariant = variants.find(v => 
              v.option1 === selectedColor && v.option2 === rowSize
            );
            
            if (matchingVariant) {
              variantId = matchingVariant.id;
              console.log(`Updated variant id for ${rowSize} (${rowColor} -> ${selectedColor}):`, variantId);
            }
          }
          
          // Create the cart item with properties from app data
          const cartItem = { 
            id: variantId, 
            quantity: qty,
            properties: {}
          };
          
          // Add app properties to the cart item
          if (Object.keys(appData).length > 0) {
            cartItem.properties = appData;
          }
          
          selections.push(cartItem);
          console.log('Selected variant to add with properties:', cartItem);
        }
      });

      if (!selections.length) {
        alert('Please select at least one size and quantity.');
        return;
      }

      const originalText = originalAddToCartText.textContent;
      originalAddToCartBtn.classList.add('btn--loading');
      originalAddToCartText.textContent = 'Adding...';

      function addNext(index) {
        if (index >= selections.length) {
          if (typeof theme.CartDrawer !== 'undefined') {
            document.dispatchEvent(new CustomEvent('cart:build'));
            document.dispatchEvent(new CustomEvent('cart:open'));
          } else {
            location.href = '/cart';
          }
          originalAddToCartBtn.classList.remove('btn--loading');
          originalAddToCartText.textContent = originalText;
          return;
        }

        console.log('Adding to cart with properties:', selections[index]);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(selections[index])
        })
        .then(response => response.json())
        .then(data => {
          console.log('Added to cart:', data);
          addNext(index + 1);
        })
        .catch(err => {
          console.error('Error adding to cart:', err);
          alert('There was an error adding items to your cart. Please try again.');
          originalAddToCartBtn.classList.remove('btn--loading');
          originalAddToCartText.textContent = originalText;
        });
      }

      addNext(0);
    });
  }

  // Run the initial render
  renderVariantRows();
}